import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

import { getNextjsFetchCacheOptions } from '@/libs/fetcher/configs'
import { payloadCmsFetcher } from '@/libs/fetcher/presets'
import { StocksContent } from '@/types/stock'

export const fetchStocksContent = (slug: string) =>
  payloadCmsFetcher<StocksContent>(`/stocks-content/${slug}`, getNextjsFetchCacheOptions(300))

export const stocksContentQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: ['stocksContent', slug],
    queryFn: () => fetchStocksContent(slug),
  })

export const useStocksContent = (slug: string) => useSuspenseQuery(stocksContentQueryOptions(slug))
